import BaseModel from "~/models/BaseModel";

class MediumWebPushNotificationModel extends BaseModel {}
export default MediumWebPushNotificationModel;
